import React from 'react';
import { Checkbox } from '@mui/material';
import {
  ManageRow,
  ManageFlexRow,
  ManageName,
  ManageItem33,
  ManageAccess,
  ManageStatus,
  ManageCheckbox,
  ManageAccessIcon,
  ManageItemSm,
  ManageItemMd,
  ManageItemLg,
  ManageXsHide,
} from './styles';
import { get, set, size } from 'global/lib/lodash';
import { Loading } from 'global/styles';
import { getUserAppPermissions } from 'global/utils';
import moment from 'moment';
import { getRealmIcon } from 'global/components/droprealms';

export const RowHeader = (props) => {
  const { hasClient } = props;

  return (
    <ManageRow headerRow>
      <ManageCheckbox>
        <Checkbox indeterminate={props.indeterminate} onClick={props.selectAll} checked={props.allSelected} />
      </ManageCheckbox>
      {hasClient ? (
        <>
          <ManageItem33>{'Name'}</ManageItem33>
          <ManageItem33>{'Email'}</ManageItem33>
          <ManageItem33>{'Access'}</ManageItem33>
        </>
      ) : (
        <>
          <ManageName>
            <ManageItemSm>{'Name'}</ManageItemSm>
            <ManageItemLg xsHide>{'Email'}</ManageItemLg>
          </ManageName>
          <ManageAccess>
            <ManageItemSm>{'Access'}</ManageItemSm>
            <ManageItemLg xsHide>{'Permissions'}</ManageItemLg>
          </ManageAccess>
          <ManageStatus>
            <ManageItemMd>{'Status'}</ManageItemMd>
            <ManageItemMd xsHide>{'Modified'}</ManageItemMd>
          </ManageStatus>
        </>
      )}
    </ManageRow>
  );
};

export default (props) => {
  const { item, index, selected, hasClient, basicDisplay } = props;

  const getAccess = () => {
    const obj = {};
    (item.realms || [])
      .filter((r) => r)
      .forEach((r) => {
        set(obj, r.tier, [...get(obj, r.tier, []), r]);
      });
    const pluralize = size(obj.community) > 1;
    const plurBuilders = size(obj.builders) > 1;
    const plurDivision = size(obj.division) > 1;
    return (
      <>
        {!!size(obj.builder) && (
          <ManageFlexRow>
            <ManageAccessIcon>{getRealmIcon({ tier: 'builder' })}</ManageAccessIcon>
            <ManageXsHide>{`${size(obj.builder)} ${plurBuilders ? 'Builders' : 'Builder'}`}</ManageXsHide>
          </ManageFlexRow>
        )}
        {!!size(obj.division) && (
          <ManageFlexRow>
            <ManageAccessIcon>{getRealmIcon({ tier: 'division' })}</ManageAccessIcon>
            <ManageXsHide>{`${size(obj.division)} ${plurDivision ? 'Divisions' : 'Division'}`}</ManageXsHide>
          </ManageFlexRow>
        )}
        {!!size(obj.community) && (
          <ManageFlexRow>
            <ManageAccessIcon>{getRealmIcon({ tier: 'community' })}</ManageAccessIcon>
            <ManageXsHide>{`${size(obj.community)} ${pluralize ? 'Communities' : 'Community'}`}</ManageXsHide>
          </ManageFlexRow>
        )}
      </>
    );
  };

  const getPermission = () => {
    const dp = getUserAppPermissions(item.permissions);
    return dp ? dp.map((d) => d.title).join(', ') : 'None';
  };

  const getUserGroups = () => {
    const dp = item.userGroups;
    return dp ? dp.map((d) => d.name).join(', ') : 'None';
  };

  const getStatus = () => {
    return get(item, 'status') === 1 ? 'Active' : 'De-Activated';
  };

  const getLastAccess = () => {
    return get(item, 'updatedAt') ? moment(get(item, 'updatedAt')).fromNow() : Loading;
  };

  const isSelected = () => {
    return get(selected, item.id) ? true : false;
  };

  const content = {
    name: get(item, 'name', Loading),
    email: get(item, 'email', Loading),
    access: getAccess(),
    permission: getPermission(),
    status: getStatus(),
    lastAccess: getLastAccess(),
    userGroups: getUserGroups(),
  };

  const onSelectItem = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onSelectItem && props.onSelectItem(props);
  };

  const onSelectRow = (e) => {
    props.onSelectRow && props.onSelectRow(props);
  };

  const showbg = index % 2;

  return (
    <ManageRow onClick={onSelectRow} listRow rowBg={!!showbg}>
      <ManageCheckbox>
        <Checkbox onClick={onSelectItem} checked={isSelected()} />
      </ManageCheckbox>
      {hasClient ? (
        <>
          <ManageItem33 item50={!!basicDisplay}>{content.name}</ManageItem33>
          <ManageItem33 item50={!!basicDisplay}>{content.email}</ManageItem33>
          {!basicDisplay && <ManageItem33>{content.access}</ManageItem33>}
        </>
      ) : (
        <>
          <ManageName>
            <ManageItemSm>{content.name}</ManageItemSm>
            <ManageItemLg>{content.email}</ManageItemLg>
          </ManageName>
          <ManageAccess>
            <ManageItemSm>{content.access}<br /><div style={{ marginBottom: 8 }}>{content.userGroups}</div></ManageItemSm>
            <ManageItemLg>{content.permission}</ManageItemLg>
          </ManageAccess>
          <ManageStatus>
            <ManageItemMd>{content.status}</ManageItemMd>
            <ManageItemMd>{content.lastAccess}</ManageItemMd>
          </ManageStatus>
        </>
      )}
    </ManageRow>
  );
};
